// extracted by mini-css-extract-plugin
export default {"container":"Chips_container__zP9jO","chip":"Chips_chip__cvL-q"};